import { Theme } from "../../../../../components/constants";

export default {
    successContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%"
    },

    cardHeading: {
        marginTop: "20px",
        width: "57%",
        textAlign: "center",
    },

    cardSubHeading: {
        marginTop: "10px",
        fontWeight: "normal",
        width: "57%",
        textAlign: "center",
    },

    grayBorder: {
        borderBottom: "0.5px solid #959AAA",
        width: "80%",
        margin: "20px 0px"
    },

    name: {
        fontWeight: "500",
        fontSize: "20px",
        color: "#252323",
    },

    questionText: {
        fontSize: "20px",
        color: "#252323",
        marginTop: "50px"
    },

    buttonsContainer: {
        display: "flex",
        columnGap: "20px",
    },

    button: {
        padding: "8px 20px"
    },

    payerRecipientRow: {
        marginTop: "40px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        width: "100%",
    },

    nameContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },

    nameDiv: {
        display: "flex",
        flexDirection: "column",
    },

    lightText:{
        lineHeight: "19px",
        color: Theme.TEXT_PRIMARY_BLACK,
    },

    nameText: {
        fontWeight: 700,
        lineHeight: "19px",
        color: "#000000"
    },
}